import { createEntityAdapter, createSlice, EntityId } from '@reduxjs/toolkit';
import { RootState } from "../index";
import {fetchAddon, fetchAddons, fetchPreviewAddons, updateAddon} from "../../actions/mine_craft/addonsActions";
import { fetchReport, fetchReports } from "../../actions/mine_craft/reportsActions";

export interface AddonInterface {
  url: string;

  id: number;

  challenge_id: number | null;
  challenge_points: number;
  challenge_rank: number | null;
  virtual_rank: number | null;

  title: string;
  search_text: string;
  description: string;
  description_html: string;
  add_type: number;
  user_id: number;
  user: number;
  image_url: string;
  texture_url: string | null;
  zip_url: string | null;
  file_url: string | null;
  config_url: string | null;
  ico_url: string;
  likes_count: number;
  downloads_count: number;
  comments_count: number;
  popular_count: number;

  published: boolean;

  created_at: string;
  updated_at: string
}

export interface initialInterface {
  error: string | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  count: number;

  editId: EntityId | null;
  editError: string | null;
}

const initialState: initialInterface = {
  error: null,
  status: 'idle',
  count: 0,

  editId: null,
  editError: null
};

const adaptor = createEntityAdapter<AddonInterface>();

const slice = createSlice({
  name: 'addons',
  initialState: adaptor.getInitialState(initialState),
  reducers: {
    setEditId: (state, action) => {
      state.editId    = action.payload;
      state.editError = initialState.editError;
    },
    setEditError: (state, action) => {
      state.editError = action.payload;
    },
    setAddons: (state, action) => {
      if (action.payload) {
        state.entities = { ...state.entities, ...action.payload };
      }
    }
  },
  extraReducers: (builder) => {
    builder
      // #index
      .addCase(fetchAddons.pending, (state, _action) => {
        state.status = 'loading'
      })
      .addCase(fetchAddons.fulfilled, (state, action) => {
        state.count = action.payload.count;
        state.entities = action.payload.addons;
        state.ids = action.payload.ids;
        state.status = 'succeeded';
      })
      .addCase(fetchAddons.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Unknown Error';
      })

      .addCase(fetchPreviewAddons.fulfilled, (state, action) => {
        state.entities = { ...state.entities, ...action.payload.addons };
      })

      // #show
      .addCase(fetchAddon.fulfilled, (state, action) => {
        const addon = Object.values(action.payload.addon)[0];
        state.entities[addon.id] = addon;
      })

      // #update
      .addCase(updateAddon.fulfilled, (state, action) => {
        const addon = Object.values(action.payload.addon)[0];
        state.entities[addon.id] = addon;
      })
      .addCase(updateAddon.rejected, (state, action) => {
        const error = Array.isArray(action.payload) ? action.payload[0] : null;
        state.editError = error || action.error.message || 'Unknown Error';
      })

      // #reports
      .addCase(fetchReports.fulfilled, (state, action) => {
        state.entities = { ...state.entities, ...action.payload.addons };
      })
      .addCase(fetchReport.fulfilled, (state, action) => {
        state.entities = { ...state.entities, ...action.payload.addon };
      })
  }
});

const reducer = slice.reducer;
export default reducer;

export const {
  setEditId,
  setEditError,
  setAddons
} = slice.actions;

export const {
  selectById: selectAddonById,
  selectIds: selectAddonIds,
  selectEntities: selectAddonEntities,
}  = adaptor.getSelectors<RootState>(state => state.mineCraft.addons);
